<script setup>
import { ref, computed, useTemplateRef } from 'vue';
import upperFirst from 'lodash/upperFirst';
import { useBus } from '/app/composables/bus';
import NModal from '/app/components/NModal.vue';
import TwitterProvider from './TwitterPreview.vue';
import FacebookProvider from './FacebookPreview.vue';
import NIcon from '/app/components/NIcon.vue';

const payload = ref(null);
const provider = ref(null);
const onShared = ref(() => {});
const onClosed = ref(() => {});

const modal = useTemplateRef('modal');

useBus({
    'sharer:share': ({ provider: p, payload: pl, onShared: os, onClosed: oc }) => {
        if (!p) {
            throw new Error('Sharer: provider is required');
        }

        provider.value = p;
        payload.value = pl;
        onShared.value = os || (() => {});
        onClosed.value = oc || (() => {});

        modal.value.open();
    },
});

const title = computed(() => `Share - ${upperFirst(provider.value || 'Social')}`);

function done() {
    onShared.value();
}
</script>

<template>
    <NModal ref="modal" :closeClickOutside="false" #default="{ visible, sharing, close }">
        <div v-if="visible" class="sharing-popup-panel m-3 transition-xy transition-transform duration-500 ease-in-out max-w-180 min-w-160">
            <div class="sharing-popup-panel__heade flex items-center justify-between bg-nerve text-white  rounded-t-lg px-4 py-2">
                <div class="flex items-center">
                    <NIcon as="share-square-solid -mt-1" class="mr-2" />
                    <h2 class="m-0 leading-none">{{ title }}</h2>
                </div>
                <button aria-label="button" type="button" class="sharing-popup-panel__close-btn" @click.prevent="onClosed() & close()">
                    <span aria-hidden="true" class="icon icon-times-circle-regular"></span>
                </button>
            </div>

            <TwitterProvider
                v-if="provider === 'twitter'"
                :content="payload"
                class="sharing-popup-panel__body"
                @cancel="close"
                @done="done"
            />

            <p v-else class="text-center py-30 text-dust-600">
                {{ provider }} is not supported yet
            </p>
        </div>
    </NModal>
</template>

